export default "__VITE_ASSET__veVMg8Sg__"